import { render, staticRenderFns } from "./RetencaoContaB.vue?vue&type=template&id=44387f9e&scoped=true"
import script from "./RetencaoContaB.vue?vue&type=script&lang=js"
export * from "./RetencaoContaB.vue?vue&type=script&lang=js"
import style0 from "./RetencaoContaB.vue?vue&type=style&index=0&id=44387f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44387f9e",
  null
  
)

export default component.exports